class StickyHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 50
    this.safeZone = 150

    this.initialColour = document.body.dataset.initialColour

    this.setColour()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.listeners.add(window, 'load', this.onLoad.bind(this))
    this.listeners.add(window, 'scroll', this.onScroll.bind(this), {
      passive: true,
    })
  }

  onLoad () {
    this.checkScrollPosition()
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
    this.updateScrollState()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    if (this.isShowAnnouncementEnabled) {
      this.setScrolled()
      this.setShowAnnouncement()
    }

    this.setColour()
  }

  checkScrollPosition () {
    if (window.scrollY > 0) {
      this.externalEls.container.element.classList.add('hd-Banner-scrolled')
    } else {
      this.externalEls.container.element.classList.remove('hd-Banner-scrolled')
    }
  }

  updateScrollState () {
    this.externalEls.container.element.classList.remove('hd-Banner-scrolled')
    this.externalEls.container.element.classList.add('hd-Banner-scrolling')

    clearTimeout(this.scrollTimeout)
    this.scrollTimeout = setTimeout(() => {
      if (window.scrollY > 0) {
        this.externalEls.container.element.classList.add('hd-Banner-scrolled')
      } else {
        this.externalEls.container.element.classList.remove(
          'hd-Banner-scrolled',
        )
      }
    }, 250)
  }

  setScrolled () {
    document.body.classList.toggle(
      this.dataset.classScrolled,
      this.shouldBeScrolled,
    )
  }

  setShowAnnouncement () {
    document.body.classList.toggle(
      this.dataset.classShowAnnouncement,
      this.shouldShowAnnouncement,
    )
  }

  setColour () {
    if (!this?.externalEls?.section?.exists) return

    this.setHeaderColour()

    if (!this?.externalEls?.['home-navigation']?.exists) return

    this.setHomeNavColour()
  }

  setHomeNavColour () {
    const homeNav = this.externalEls[
      'home-navigation'
    ].element.getBoundingClientRect()

    this.externalEls.section.elements.some(sectionEl => {
      const section = sectionEl.getBoundingClientRect()
      if (
        section.top <= homeNav.top &&
        section.top + section.height > homeNav.top
      ) {
        this.navigationColour = `${sectionEl.dataset.navigationColour}`

        document.documentElement.style.setProperty(
          '--Nav_Color',
          this.navigationColour,
        )

        return true
      }

      document.documentElement.style.setProperty(
        '--Nav_Color',
        this.initialColour,
      )

      return false
    })
  }

  setHeaderColour () {
    const header = this.getBoundingClientRect()

    this.externalEls.section.elements.some(sectionEl => {
      const section = sectionEl.getBoundingClientRect()
      if (
        section.top <= header.top &&
        section.top + section.height > header.top
      ) {
        this.navigationColour = `${sectionEl.dataset.navigationColour}`

        document.documentElement.style.setProperty(
          '--Header_Color',
          this.navigationColour,
        )

        return true
      }

      document.documentElement.style.setProperty(
        '--Header_Color',
        this.initialColour,
      )

      return false
    })
  }

  get shouldBeScrolled () {
    return this.lastKnownY >= this.safeZone
  }

  get shouldShowAnnouncement () {
    if (this.lastKnownY < this.safeZone) {
      return false
    }

    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get isShowAnnouncementEnabled () {
    return this.dataset.showAnnouncement === 'true'
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader)
}
